import { SegmentationIds } from 'constants/segmentation';

export default {
  [`personalized-ribbon-${SegmentationIds.Intolerance}`]: '<b>Bestseller</b>  bij allergieën',
  [`personalized-ribbon-${SegmentationIds.PickyEater}`]: '<b>Bestseller</b> voor kieskeurige eters',
  [`personalized-ribbon-${SegmentationIds.Overweight}`]: '<b>Bestseller</b>  bij overgewicht',
  [`personalized-ribbon-${SegmentationIds.Digestion}`]:
    '<b>Bestseller</b>  bij een gevoelige spijsvertering',
  [`personalized-ribbon-${SegmentationIds.Overweight}`]:
    '<b>Bestseller</b>  voor honden met overgewicht',
  [`personalized-ribbon-${SegmentationIds.SkinFur}`]:
    '<b>Bestseller</b>  bij huid- & vachtproblemen',
  [`personalized-ribbon-${SegmentationIds.Welpe}`]: "<b>Bestseller</b>  voor puppy's ",
  [`personalized-ribbon-${SegmentationIds.DogSenior}`]: '<b>Bestseller</b>  voor senioren ',
  [`personalized-ribbon-${SegmentationIds.Bulldog}`]: '<b>Bestseller</b>  voor bulldoggen',
  [`personalized-ribbon-${SegmentationIds.Chihuahua}`]: '<b>Bestseller</b>  voor chihuahuas',
  [`personalized-ribbon-${SegmentationIds.Dachshund}`]: '<b>Bestseller</b>  voor teckels',
  [`personalized-ribbon-${SegmentationIds.Havanese}`]:
    '<b>Bestseller</b>  voor maltezers & havanezers',
  [`personalized-ribbon-${SegmentationIds.Poodle}`]: '<b>Bestseller</b>  voor poedels',
  [`personalized-ribbon-${SegmentationIds.Retriever}`]: '<b>Bestseller</b>  voor retrievers',
  [`personalized-ribbon-${SegmentationIds.ShepherdDog}`]: '<b>Bestseller</b>  voor herdershonden',
  [`personalized-ribbon-${SegmentationIds.Spitz}`]: '<b>Bestseller</b>  voor spitsen',
  [`personalized-ribbon-${SegmentationIds.Terrier}`]: '<b>Bestseller</b>  voor terriërs',
  [`personalized-ribbon-${SegmentationIds.Herdingdog}`]: '<b>Bestseller</b>  voor herdershonden',
  [`personalized-ribbon-${SegmentationIds.CatPickyEater}`]:
    '<b>Bestseller</b>  voor kieskeurige eters',
  [`personalized-ribbon-${SegmentationIds.CatDigestion}`]:
    '<b>Bestseller</b>  bij een gevoelige spijsvertering',
  [`personalized-ribbon-${SegmentationIds.CatOverweight}`]:
    '<b>Bestseller</b>  voor katten met overgewicht',
  [`personalized-ribbon-${SegmentationIds.Kitten}`]: '<b>Bestseller</b>  voor kittens (0-1 jaar)',
  [`personalized-ribbon-${SegmentationIds.CatSenior}`]:
    '<b>Bestseller</b>  voor senioren (10+ jaar)',
};
